import type { StoreResponse } from '@clarity/contract';
import { StatementsView, SyncControl } from './shared.js';

/**
 * The standalone Statements page for one onboarded store (clarity-orders-detail
 * task 4.1, Req 1.1–1.3). It is its OWN page at `/c/:clientId/<scope>/statements`
 * — no `?tab=` tab host. The body is the UNCHANGED single-store
 * {@link StatementsView} (its month blocks + per-period reconciliation verdicts),
 * framed by the shared per-store header so "Sync now" stays available on each
 * standalone page.
 */
export function StoreStatements({ store }: { store: StoreResponse }) {
  return (
    <section>
      <SyncControl store={store} />
      <StatementsView store={store} />
    </section>
  );
}
